import { RegistrationPurpose } from '@commenda/types/src/registration/types';
import { SWRFetcher } from '@commenda/utils';
import { useMemo } from 'react';
import useSWR, { KeyedMutator } from 'swr';

export type TRegistrationPurposeOption = {
  value: RegistrationPurpose;
  label: string;
};

/** The purposes a registration can have, named. The backend owns the vocabulary and its labels. */
export function useRegistrationPurposes() {
  const {
    data,
    error,
    mutate,
  }: {
    data?: { purposes: TRegistrationPurposeOption[]; count: number };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    'business-entities/registrations/purposes',
    SWRFetcher({
      method: 'GET',
    })
  );

  const purposes = data?.purposes ?? [];

  // Stable, so a caller can read it inside a memo. Reads data directly: purposes is a fresh array
  // on every render until the fetch lands, and depending on that would defeat the memo.
  const purposeLabels = useMemo(
    () =>
      new Map(
        (data?.purposes ?? []).map((purpose) => [purpose.value, purpose.label])
      ),
    [data?.purposes]
  );

  return { purposes, purposeLabels, error, mutate };
}
